var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.839,
    height: 18.216,
    viewBox: "0 0 14.839 18.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-webcomponents-dot-org",
    "data-name": "Icon simple-webcomponents-dot-org",
    d: "M8.9,3.338,8.9,3.35H4.263L0,10.741l4.264,7.39h9.715l.03.046,1.62-2.835.393-.678h-.006l.006-.011-.475-.569h.679l0-.008.006.008,1.979-3.331L16.236,7.42l0,0-.008-.014h-.717l.479-.58L14.008,3.362l0,.008-.018-.03H8.9ZM6.911,6.828h4.7l-.4.58h-.018l1.82,3.048h.664l-.21.249.271.33h-.726l-1.82,3.048h.02l.4.58H6.886L4.616,10.74,6.91,6.827Z",
    transform: "translate(-3.337 18.214) rotate(-90)",
    fill: "#868686"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubOrg);
export default __webpack_public_path__ + "static/media/sub-org.132806e9b5d79ab4afb1df5515579962.svg";
export { ForwardRef as ReactComponent };